/**
 * @generated SignedSource<<028df322ace0e854b9d22063519d15bd>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "MapSidebarTitle_map",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "allowSendingNotificationOnContentUpdate",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ResourceTreeTaxonomy",
      "kind": "LinkedField",
      "name": "taxonomies",
      "plural": true,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "TaxonomyIcons_taxonomies"
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "Breadcrumbs_page"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "Subscription_subscribable"
    }
  ],
  "type": "ResourceTreeLeaf",
  "abstractKey": "__isResourceTreeLeaf"
};

node.hash = "0cbf6361ad134d82b389ac1e2bbfb0ef";

module.exports = node;
